import { AppValues } from '@/helpers/const';

const CONTACT_DETAILS_IN_USE_MESSAGE = `Applicant's contact details are already in use. Please verify the information or use different contact details.`;

/**
 * Maps the backend's application submission error codes to a message the broker can act on.
 * Anything not listed is a genuine system failure and gets the generic message.
 */
const SUBMISSION_ERROR_MESSAGES: Record<string, string> = {
  'applicant-already-exists-error': CONTACT_DETAILS_IN_USE_MESSAGE,
  'application-cancellation-error': CONTACT_DETAILS_IN_USE_MESSAGE,
  // The backend looks every property address up by postcode; a missing or unknown one is
  // rejected before anything is saved (JS-10505).
  'invalid-post-code-error':
    'Could not submit your application: a property address has a missing or invalid postcode. Please check the addresses in the Property details and Loan purpose steps, then try again.',
};

export const getSubmissionErrorMessage = (error: string | undefined): string =>
  (error && SUBMISSION_ERROR_MESSAGES[error]) ||
  `A system error has occurred. Please try again otherwise contact ${AppValues.COMPANY_NAME} on ${AppValues.CONTACT} for support`;
